(ns frontend.ui.component.lp-portal.header.view
  (:require
   [frontend.lp-portal.routes :as routes]
   [frontend.lp-portal.sub :as portal-sub]
   [frontend.lp-portal.event :as lp-portal-event]
   [frontend.ui.component.lp-portal.header.style :as style]
   [frontend.ui.component.burger-menu.view :refer [burger-menu]]
   [herb.core :refer [<class]]
   [reagent.core :as r]
   [reitit.frontend.easy :as reitit-e]
   [re-frame.core :as rf]
   [common.util :as cu]
   [common.localization :as loc]))

(defn nav-items
  []
  (let [tenant @(rf/subscribe [::portal-sub/tenant])]
    [{:id     "archive"
      :href   (reitit-e/href ::routes/archive)
      :hiccup "Archive"}
     {:id     "contact-us"
      :href   (str "mailto:" (:tenant/reporting-contact-email tenant))
      :target "_blank"
      :hiccup "Contact us"}
     {:id     "log-out"
      :href   "/logout"
      :hiccup "Log out"}]))

(defn header
  [hide-burger?]
  (let [tenant @(rf/subscribe [::portal-sub/tenant])
        admin? @(rf/subscribe [::portal-sub/admin?])
        user-email @(rf/subscribe [::portal-sub/user-email])
        simulated-email @(rf/subscribe [::portal-sub/simulated-email])
        contacts @(rf/subscribe [::portal-sub/landing-page-all-lp-guests-path])]
    [:div
     {:class (<class style/header)}
     [:div
      {:class (<class style/header-content)}
      [:a
       {:href "/"}
       [:img
        {:class (<class style/header-logo-image-mobile)
         :src   (:tenant/reporting-logo-grey tenant)}]
       [:img
        {:class (<class style/header-logo-image-desktop)
         :src   (:tenant/reporting-logo-white tenant)}]]
      (when admin?
        (into [:select
               {:class     (<class style/admin-user-select)
                :value     (or simulated-email user-email)
                :on-change (fn [e]
                             (let [selected-value (some-> e
                                                          .-target
                                                          .-value)]
                               (rf/dispatch [::lp-portal-event/simulate-user selected-value])
                             ))}]
              (->> contacts
                   (sort-by (fn [{:keys [email]}]
                              (cu/str-trim-lcase email)))
                   (map (fn [person]
                          ^{:key (str (:db/id person) (:email person))}
                          [:option
                           {:value (:email person)
                            :label (:display-name person)}]))
                   (concat [[:option
                             {:value user-email
                              :label (loc/tr :logged-in-user [user-email])}]]))))
      [:div
       {:class (<class style/header-menu)}
       (when-not hide-burger?
         (r/as-element
          [burger-menu
           {:items  (nav-items)
            :right? true
            :width  "100%"}]))]]]))
